export function ensureLeadingSlash(url: string): string {
  if (url[0] === '/') {
    return url;
  }

  return '/' + url;
}

export const ensureNoLeadingSlash = (url: string): string => url.replace(/^\/+/, '');

export const ensureNoTrailingSlash = (url: string): string => {
  const [pathname, search] = url.split('?');
  return (pathname.endsWith('/') ? pathname.slice(0, -1) : pathname) + (search ? `?${search}` : '');
};
